import { css } from '@emotion/react';

type ReviewsEmptyStateProps = {
  size?: number;
};

export const ReviewsEmptyState = ({ size = 600 }: ReviewsEmptyStateProps) => (
  <svg
    id='Layer_1'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 599.06 599.06'
    css={css`
      width: ${size}px;
      height: ${size}px;
      .cls-1 {
        clip-path: url(#clippath);
      }

      .cls-2 {
        fill: none;
      }

      .cls-2,
      .cls-3,
      .cls-4,
      .cls-5,
      .cls-6,
      .cls-7,
      .cls-8,
      .cls-9,
      .cls-10,
      .cls-11,
      .cls-12,
      .cls-13,
      .cls-14,
      .cls-15,
      .cls-16,
      .cls-17,
      .cls-18,
      .cls-19,
      .cls-20,
      .cls-21,
      .cls-22,
      .cls-23,
      .cls-24,
      .cls-25,
      .cls-26,
      .cls-27,
      .cls-28,
      .cls-29,
      .cls-30,
      .cls-31,
      .cls-32,
      .cls-33,
      .cls-34,
      .cls-35,
      .cls-36,
      .cls-37,
      .cls-38,
      .cls-39,
      .cls-40,
      .cls-41,
      .cls-42,
      .cls-43,
      .cls-44,
      .cls-45,
      .cls-46,
      .cls-47,
      .cls-48,
      .cls-49,
      .cls-50,
      .cls-51,
      .cls-52,
      .cls-53,
      .cls-54,
      .cls-55,
      .cls-56,
      .cls-57,
      .cls-58,
      .cls-59,
      .cls-60,
      .cls-61,
      .cls-62,
      .cls-63,
      .cls-64,
      .cls-65,
      .cls-66,
      .cls-67,
      .cls-68,
      .cls-69,
      .cls-70,
      .cls-71,
      .cls-72,
      .cls-73,
      .cls-74,
      .cls-75,
      .cls-76,
      .cls-77,
      .cls-78,
      .cls-79,
      .cls-80,
      .cls-81,
      .cls-82,
      .cls-83,
      .cls-84,
      .cls-85,
      .cls-86,
      .cls-87,
      .cls-88,
      .cls-89,
      .cls-90,
      .cls-91,
      .cls-92,
      .cls-93,
      .cls-94,
      .cls-95,
      .cls-96,
      .cls-97,
      .cls-98,
      .cls-99,
      .cls-100,
      .cls-101,
      .cls-102,
      .cls-103,
      .cls-104,
      .cls-105,
      .cls-106,
      .cls-107,
      .cls-108,
      .cls-109,
      .cls-110,
      .cls-111,
      .cls-112,
      .cls-113,
      .cls-114,
      .cls-115,
      .cls-116,
      .cls-117,
      .cls-118,
      .cls-119,
      .cls-120,
      .cls-121,
      .cls-122,
      .cls-123,
      .cls-124,
      .cls-125,
      .cls-126,
      .cls-127,
      .cls-128,
      .cls-129,
      .cls-130,
      .cls-131,
      .cls-132,
      .cls-133,
      .cls-134,
      .cls-135 {
        stroke-width: 0px;
      }

      .cls-136 {
        clip-path: url(#clippath-1);
      }

      .cls-137 {
        clip-path: url(#clippath-2);
      }

      .cls-3 {
        fill: #3f8bfd;
      }

      .cls-4 {
        fill: #dcebfe;
      }

      .cls-5 {
        fill: #9ec5ff;
      }

      .cls-6 {
        fill: #ffcb13;
      }

      .cls-7 {
        fill: #ffcb11;
      }

      .cls-8 {
        fill: #ffcb12;
      }

      .cls-9 {
        fill: #ffcb14;
      }

      .cls-10 {
        fill: #ffcb10;
      }

      .cls-11 {
        fill: #ffe37e;
      }

      .cls-12 {
        fill: #ffdc5f;
      }

      .cls-13 {
        fill: #ffdc60;
      }

      .cls-14 {
        fill: #ffdc61;
      }

      .cls-15 {
        fill: #ffdc62;
      }

      .cls-16 {
        fill: #ffdc5e;
      }

      .cls-17 {
        fill: #ffe380;
      }

      .cls-18 {
        fill: #ffe37f;
      }

      .cls-19 {
        fill: #fff;
      }

      .cls-20 {
        fill: #ffe27d;
      }

      .cls-21 {
        fill: #ffe27a;
      }

      .cls-22 {
        fill: #ffe27c;
      }

      .cls-23 {
        fill: #ffe27b;
      }

      .cls-24 {
        fill: #ffdb5b;
      }

      .cls-25 {
        fill: #ffdb5c;
      }

      .cls-26 {
        fill: #ffdb5a;
      }

      .cls-27 {
        fill: #ffdb5d;
      }

      .cls-28 {
        fill: #ffe178;
      }

      .cls-29 {
        fill: #ffe179;
      }

      .cls-30 {
        fill: #ffe177;
      }

      .cls-31 {
        fill: #ffe175;
      }

      .cls-32 {
        fill: #ffe176;
      }

      .cls-33 {
        fill: #ffeeb2;
      }

      .cls-34 {
        fill: #ffda58;
      }

      .cls-35 {
        fill: #ffda55;
      }

      .cls-36 {
        fill: #ffda56;
      }

      .cls-37 {
        fill: #ffdf6d;
      }

      .cls-38 {
        fill: #ffdf6f;
      }

      .cls-39 {
        fill: #ffdf6c;
      }

      .cls-40 {
        fill: #ffdf6e;
      }

      .cls-41 {
        fill: #ffdf70;
      }

      .cls-42 {
        fill: #ffda57;
      }

      .cls-43 {
        fill: #ffda59;
      }

      .cls-44 {
        fill: #ffd953;
      }

      .cls-45 {
        fill: #ffd954;
      }

      .cls-46 {
        fill: #ffd951;
      }

      .cls-47 {
        fill: #ffd952;
      }

      .cls-48 {
        fill: #ffd02b;
      }

      .cls-49 {
        fill: #ffd027;
      }

      .cls-50 {
        fill: #ffd028;
      }

      .cls-51 {
        fill: #ffd02a;
      }

      .cls-52 {
        fill: #ffd029;
      }

      .cls-53 {
        fill: #ffcf23;
      }

      .cls-54 {
        fill: #ffcf24;
      }

      .cls-55 {
        fill: #ffcf25;
      }

      .cls-56 {
        fill: #ffcf26;
      }

      .cls-57 {
        fill: #ffd230;
      }

      .cls-58 {
        fill: #ffd231;
      }

      .cls-59 {
        fill: #ffd232;
      }

      .cls-60 {
        fill: #ffd335;
      }

      .cls-61 {
        fill: #ffd337;
      }

      .cls-62 {
        fill: #ffd338;
      }

      .cls-63 {
        fill: #ffd336;
      }

      .cls-64 {
        fill: #ffd12f;
      }

      .cls-65 {
        fill: #ffd12e;
      }

      .cls-66 {
        fill: #ffd12d;
      }

      .cls-67 {
        fill: #ffd12c;
      }

      .cls-68 {
        fill: #ffc804;
      }

      .cls-69 {
        fill: #ffc806;
      }

      .cls-70 {
        fill: #ffc805;
      }

      .cls-71 {
        fill: #ffc803;
      }

      .cls-72 {
        fill: #ffd234;
      }

      .cls-73 {
        fill: #ffd233;
      }

      .cls-74 {
        fill: #ffd647;
      }

      .cls-75 {
        fill: #ffd646;
      }

      .cls-76 {
        fill: #ffd643;
      }

      .cls-77 {
        fill: #ffd645;
      }

      .cls-78 {
        fill: #ffca0c;
      }

      .cls-79 {
        fill: #ffca0f;
      }

      .cls-80 {
        fill: #ffca0e;
      }

      .cls-81 {
        fill: #ffca0d;
      }

      .cls-82 {
        fill: #ffd644;
      }

      .cls-83 {
        fill: #ffce1e;
      }

      .cls-84 {
        fill: #ffce1f;
      }

      .cls-85 {
        fill: #ffce22;
      }

      .cls-86 {
        fill: #ffcd19;
      }

      .cls-87 {
        fill: #ffcd1b;
      }

      .cls-88 {
        fill: #ffcd1a;
      }

      .cls-89 {
        fill: #ffd84c;
      }

      .cls-90 {
        fill: #ffc907;
      }

      .cls-91 {
        fill: #ffd84d;
      }

      .cls-92 {
        fill: #ffd53f;
      }

      .cls-93 {
        fill: #ffd53e;
      }

      .cls-94 {
        fill: #ffd43d;
      }

      .cls-95 {
        fill: #ffd43b;
      }

      .cls-96 {
        fill: #ffcd1d;
      }

      .cls-97 {
        fill: #ffcd1c;
      }

      .cls-98 {
        fill: #ffd541;
      }

      .cls-99 {
        fill: #ffd542;
      }

      .cls-100 {
        fill: #ffcc15;
      }

      .cls-101 {
        fill: #ffc702;
      }

      .cls-102 {
        fill: #ffc700;
      }

      .cls-103 {
        fill: #ffc701;
      }

      .cls-104 {
        fill: #ffd43c;
      }

      .cls-105 {
        fill: #ffd748;
      }

      .cls-106 {
        fill: #ffd74b;
      }

      .cls-107 {
        fill: #ffd74a;
      }

      .cls-108 {
        fill: #ffd749;
      }

      .cls-109 {
        fill: #ffce21;
      }

      .cls-110 {
        fill: #ffce20;
      }

      .cls-111 {
        fill: #ffc909;
      }

      .cls-112 {
        fill: #ffcc16;
      }

      .cls-113 {
        fill: #ffd84f;
      }

      .cls-114 {
        fill: #ffd850;
      }

      .cls-115 {
        fill: #ffc908;
      }

      .cls-116 {
        fill: #ffcc17;
      }

      .cls-117 {
        fill: #ffcc18;
      }

      .cls-118 {
        fill: #ffd84e;
      }

      .cls-119 {
        fill: #ffd43a;
      }

      .cls-120 {
        fill: #ffd439;
      }

      .cls-121 {
        fill: #ebf3ff;
      }

      .cls-122 {
        fill: #ffde6b;
      }

      .cls-123 {
        fill: #ffde68;
      }

      .cls-124 {
        fill: #ffde69;
      }

      .cls-125 {
        fill: #ffe071;
      }

      .cls-126 {
        fill: #ffe072;
      }

      .cls-127 {
        fill: #ffdd63;
      }

      .cls-128 {
        fill: #ffdd67;
      }

      .cls-129 {
        fill: #ffdd65;
      }

      .cls-130 {
        fill: #ffdd64;
      }

      .cls-131 {
        fill: #ffde6a;
      }

      .cls-132 {
        fill: #fd6;
      }

      .cls-133 {
        fill: #ffe073;
      }

      .cls-134 {
        fill: #ffe074;
      }

      .cls-135 {
        fill: #002f75;
      }
    `}
  >
    <defs>
      <clipPath id='clippath'>
        <path
          className='cls-2'
          d='M408.01,321.16l20.1,35.86c.48.86,1.36,1.43,2.34,1.52l40.93,3.77c2.47.23,3.61,3.19,1.93,5.02l-27.89,30.19c-.67.72-.94,1.73-.72,2.7l9.06,40.1c.55,2.42-1.92,4.42-4.18,3.38l-37.34-17.2c-.9-.41-1.94-.36-2.79.15l-35.33,21.01c-2.14,1.27-4.8-.46-4.51-2.93l4.82-40.82c.12-.98-.26-1.95-1-2.6l-30.9-27.11c-1.87-1.64-1.05-4.71,1.39-5.19l40.31-8.03c.97-.19,1.78-.85,2.17-1.76l16.24-37.76c.98-2.28,4.15-2.45,5.37-.28Z'
        />
      </clipPath>
      <clipPath id='clippath-1'>
        <path
          className='cls-2'
          d='M452.59,107.32l16.49,56.52c.4,1.36,1.43,2.43,2.78,2.87l55.91,18.45c3.38,1.12,4.01,5.62,1.07,7.63l-48.65,33.15c-1.17.8-1.87,2.12-1.88,3.53l-.28,58.87c-.02,3.56-4.11,5.55-6.92,3.38l-46.56-36.03c-1.12-.86-2.59-1.12-3.94-.69l-56.08,17.93c-3.39,1.08-6.55-2.19-5.35-5.54l19.88-55.42c.48-1.33.27-2.81-.56-3.96l-34.38-47.79c-2.08-2.89.06-6.91,3.62-6.8l58.85,1.78c1.41.04,2.76-.61,3.59-1.75l34.83-47.47c2.11-2.87,6.59-2.08,7.58,1.34Z'
        />
      </clipPath>
      <clipPath id='clippath-2'>
        <path
          className='cls-2'
          d='M191.02,168l50.8,69.24c1.22,1.66,3.18,2.62,5.24,2.56l85.83-2.6c5.19-.16,8.31,5.7,5.27,9.92l-50.15,69.71c-1.2,1.67-1.51,3.83-.81,5.77l28.99,80.83c1.75,4.89-2.86,9.66-7.8,8.08l-81.79-26.16c-1.96-.63-4.11-.25-5.74,1.01l-67.92,52.55c-4.11,3.18-10.07.27-10.1-4.92l-.4-85.87c0-2.06-1.03-3.99-2.74-5.15l-70.97-48.35c-4.29-2.92-3.37-9.5,1.56-11.12l81.55-26.92c1.96-.65,3.47-2.21,4.05-4.19l24.06-82.44c1.45-4.98,7.99-6.14,11.06-1.95Z'
        />
      </clipPath>
    </defs>
    <circle className='cls-121' cx='299.66' cy='310.5' r='223.71' />
    <g className='cls-1'>
      <polygon className='cls-17' points='469.51 318.99 340.66 325.75 340.66 318.99 469.51 318.99' />
      <polygon
        className='cls-17'
        points='474.99 319.52 340.66 326.56 340.66 325.75 469.51 318.99 474.99 318.99 474.99 319.52'
      />
      <polygon className='cls-18' points='474.99 320.34 340.66 327.38 340.66 326.56 474.99 319.52 474.99 320.34' />
      <polygon className='cls-11' points='474.99 321.16 340.66 328.2 340.66 327.38 474.99 320.34 474.99 321.16' />
      <polygon className='cls-20' points='474.99 321.98 340.66 329.02 340.66 328.2 474.99 321.16 474.99 321.98' />
      <polygon className='cls-22' points='474.99 322.8 340.66 329.84 340.66 329.02 474.99 321.98 474.99 322.8' />
      <polygon className='cls-23' points='474.99 323.62 340.66 330.66 340.66 329.84 474.99 322.8 474.99 323.62' />
      <polygon className='cls-21' points='474.99 324.44 340.66 331.48 340.66 330.66 474.99 323.62 474.99 324.44' />
      <polygon className='cls-29' points='474.99 325.26 340.66 332.3 340.66 331.48 474.99 324.44 474.99 325.26' />
      <polygon className='cls-28' points='474.99 326.08 340.66 333.12 340.66 332.3 474.99 325.26 474.99 326.08' />
      <polygon className='cls-30' points='474.99 326.89 340.66 333.93 340.66 333.12 474.99 326.08 474.99 326.89' />
      <polygon className='cls-32' points='474.99 327.71 340.66 334.75 340.66 333.93 474.99 326.89 474.99 327.71' />
      <polygon className='cls-31' points='474.99 328.53 340.66 335.57 340.66 334.75 474.99 327.71 474.99 328.53' />
      <polygon className='cls-134' points='474.99 329.35 340.66 336.39 340.66 335.57 474.99 328.53 474.99 329.35' />
      <polygon className='cls-133' points='474.99 330.17 340.66 337.21 340.66 336.39 474.99 329.35 474.99 330.17' />
      <polygon className='cls-126' points='474.99 330.99 340.66 338.03 340.66 337.21 474.99 330.17 474.99 330.99' />
      <polygon className='cls-125' points='474.99 331.81 340.66 338.85 340.66 338.03 474.99 330.99 474.99 331.81' />
      <polygon className='cls-41' points='474.99 332.63 340.66 339.67 340.66 338.85 474.99 331.81 474.99 332.63' />
      <polygon className='cls-38' points='474.99 333.44 340.66 340.48 340.66 339.67 474.99 332.63 474.99 333.44' />
      <polygon className='cls-40' points='474.99 334.26 340.66 341.3 340.66 340.48 474.99 333.44 474.99 334.26' />
      <polygon className='cls-37' points='474.99 335.08 340.66 342.12 340.66 341.3 474.99 334.26 474.99 335.08' />
      <polygon className='cls-39' points='474.99 335.9 340.66 342.94 340.66 342.12 474.99 335.08 474.99 335.9' />
      <polygon className='cls-122' points='474.99 336.72 340.66 343.76 340.66 342.94 474.99 335.9 474.99 336.72' />
      <polygon className='cls-131' points='474.99 337.54 340.66 344.58 340.66 343.76 474.99 336.72 474.99 337.54' />
      <polygon className='cls-124' points='474.99 338.36 340.66 345.4 340.66 344.58 474.99 337.54 474.99 338.36' />
      <polygon className='cls-123' points='474.99 339.18 340.66 346.22 340.66 345.4 474.99 338.36 474.99 339.18' />
      <polygon className='cls-128' points='474.99 340 340.66 347.04 340.66 346.22 474.99 339.18 474.99 340' />
      <polygon className='cls-132' points='474.99 340.81 340.66 347.85 340.66 347.04 474.99 340 474.99 340.81' />
      <polygon className='cls-129' points='474.99 341.63 340.66 348.67 340.66 347.85 474.99 340.81 474.99 341.63' />
      <polygon className='cls-130' points='474.99 342.45 340.66 349.49 340.66 348.67 474.99 341.63 474.99 342.45' />
      <polygon className='cls-127' points='474.99 343.27 340.66 350.31 340.66 349.49 474.99 342.45 474.99 343.27' />
      <polygon className='cls-15' points='474.99 344.09 340.66 351.13 340.66 350.31 474.99 343.27 474.99 344.09' />
      <polygon className='cls-14' points='474.99 344.91 340.66 351.95 340.66 351.13 474.99 344.09 474.99 344.91' />
      <polygon className='cls-13' points='474.99 345.73 340.66 352.77 340.66 351.95 474.99 344.91 474.99 345.73' />
      <polygon className='cls-12' points='474.99 346.55 340.66 353.59 340.66 352.77 474.99 345.73 474.99 346.55' />
      <polygon className='cls-16' points='474.99 347.36 340.66 354.4 340.66 353.59 474.99 346.55 474.99 347.36' />
      <polygon className='cls-27' points='474.99 348.18 340.66 355.22 340.66 354.4 474.99 347.36 474.99 348.18' />
      <polygon className='cls-25' points='474.99 349 340.66 356.04 340.66 355.22 474.99 348.18 474.99 349' />
      <polygon className='cls-24' points='474.99 349.82 340.66 356.86 340.66 356.04 474.99 349 474.99 349.82' />
      <polygon className='cls-26' points='474.99 350.64 340.66 357.68 340.66 356.86 474.99 349.82 474.99 350.64' />
      <polygon className='cls-43' points='474.99 351.46 340.66 358.5 340.66 357.68 474.99 350.64 474.99 351.46' />
      <polygon className='cls-34' points='474.99 352.28 340.66 359.32 340.66 358.5 474.99 351.46 474.99 352.28' />
      <polygon className='cls-42' points='474.99 353.1 340.66 360.14 340.66 359.32 474.99 352.28 474.99 353.1' />
      <polygon className='cls-36' points='474.99 353.91 340.66 360.95 340.66 360.14 474.99 353.1 474.99 353.91' />
      <polygon className='cls-35' points='474.99 354.73 340.66 361.77 340.66 360.95 474.99 353.91 474.99 354.73' />
      <polygon className='cls-45' points='474.99 355.55 340.66 362.59 340.66 361.77 474.99 354.73 474.99 355.55' />
      <polygon className='cls-44' points='474.99 356.37 340.66 363.41 340.66 362.59 474.99 355.55 474.99 356.37' />
      <polygon className='cls-47' points='474.99 357.19 340.66 364.23 340.66 363.41 474.99 356.37 474.99 357.19' />
      <polygon className='cls-46' points='474.99 358.01 340.66 365.05 340.66 364.23 474.99 357.19 474.99 358.01' />
      <polygon className='cls-114' points='474.99 358.83 340.66 365.87 340.66 365.05 474.99 358.01 474.99 358.83' />
      <polygon className='cls-113' points='474.99 359.65 340.66 366.69 340.66 365.87 474.99 358.83 474.99 359.65' />
      <polygon className='cls-118' points='474.99 360.47 340.66 367.51 340.66 366.69 474.99 359.65 474.99 360.47' />
      <polygon className='cls-91' points='474.99 361.28 340.66 368.32 340.66 367.51 474.99 360.47 474.99 361.28' />
      <polygon className='cls-89' points='474.99 362.1 340.66 369.14 340.66 368.32 474.99 361.28 474.99 362.1' />
      <polygon className='cls-106' points='474.99 362.92 340.66 369.96 340.66 369.14 474.99 362.1 474.99 362.92' />
      <polygon className='cls-107' points='474.99 363.74 340.66 370.78 340.66 369.96 474.99 362.92 474.99 363.74' />
      <polygon className='cls-108' points='474.99 364.56 340.66 371.6 340.66 370.78 474.99 363.74 474.99 364.56' />
      <polygon className='cls-105' points='474.99 365.38 340.66 372.42 340.66 371.6 474.99 364.56 474.99 365.38' />
      <polygon className='cls-74' points='474.99 366.2 340.66 373.24 340.66 372.42 474.99 365.38 474.99 366.2' />
      <polygon className='cls-75' points='474.99 367.02 340.66 374.06 340.66 373.24 474.99 366.2 474.99 367.02' />
      <polygon className='cls-77' points='474.99 367.83 340.66 374.87 340.66 374.06 474.99 367.02 474.99 367.83' />
      <polygon className='cls-82' points='474.99 368.65 340.66 375.69 340.66 374.87 474.99 367.83 474.99 368.65' />
      <polygon className='cls-76' points='474.99 369.47 340.66 376.51 340.66 375.69 474.99 368.65 474.99 369.47' />
      <polygon className='cls-99' points='474.99 370.29 340.66 377.33 340.66 376.51 474.99 369.47 474.99 370.29' />
      <polygon className='cls-98' points='474.99 371.11 340.66 378.15 340.66 377.33 474.99 370.29 474.99 371.11' />
      <polygon className='cls-92' points='474.99 371.93 340.66 378.97 340.66 378.15 474.99 371.11 474.99 371.93' />
      <polygon className='cls-93' points='474.99 372.75 340.66 379.79 340.66 378.97 474.99 371.93 474.99 372.75' />
      <polygon className='cls-94' points='474.99 373.57 340.66 380.61 340.66 379.79 474.99 372.75 474.99 373.57' />
      <polygon className='cls-104' points='474.99 374.39 340.66 381.43 340.66 380.61 474.99 373.57 474.99 374.39' />
      <polygon className='cls-95' points='474.99 375.2 340.66 382.24 340.66 381.43 474.99 374.39 474.99 375.2' />
      <polygon className='cls-119' points='474.99 376.02 340.66 383.06 340.66 382.24 474.99 375.2 474.99 376.02' />
      <polygon className='cls-120' points='474.99 376.84 340.66 383.88 340.66 383.06 474.99 376.02 474.99 376.84' />
      <polygon className='cls-62' points='474.99 377.66 340.66 384.7 340.66 383.88 474.99 376.84 474.99 377.66' />
      <polygon className='cls-61' points='474.99 378.48 340.66 385.52 340.66 384.7 474.99 377.66 474.99 378.48' />
      <polygon className='cls-63' points='474.99 379.3 340.66 386.34 340.66 385.52 474.99 378.48 474.99 379.3' />
      <polygon className='cls-60' points='474.99 380.12 340.66 387.16 340.66 386.34 474.99 379.3 474.99 380.12' />
      <polygon className='cls-72' points='474.99 380.94 340.66 387.98 340.66 387.16 474.99 380.12 474.99 380.94' />
      <polygon className='cls-73' points='474.99 381.75 340.66 388.79 340.66 387.98 474.99 380.94 474.99 381.75' />
      <polygon className='cls-59' points='474.99 382.57 340.66 389.61 340.66 388.79 474.99 381.75 474.99 382.57' />
      <polygon className='cls-58' points='474.99 383.39 340.66 390.43 340.66 389.61 474.99 382.57 474.99 383.39' />
      <polygon className='cls-57' points='474.99 384.21 340.66 391.25 340.66 390.43 474.99 383.39 474.99 384.21' />
      <polygon className='cls-64' points='474.99 385.03 340.66 392.07 340.66 391.25 474.99 384.21 474.99 385.03' />
      <polygon className='cls-65' points='474.99 385.85 340.66 392.89 340.66 392.07 474.99 385.03 474.99 385.85' />
      <polygon className='cls-66' points='474.99 386.67 340.66 393.71 340.66 392.89 474.99 385.85 474.99 386.67' />
      <polygon className='cls-67' points='474.99 387.49 340.66 394.53 340.66 393.71 474.99 386.67 474.99 387.49' />
      <polygon className='cls-48' points='474.99 388.3 340.66 395.35 340.66 394.53 474.99 387.49 474.99 388.3' />
      <polygon className='cls-51' points='474.99 389.12 340.66 396.16 340.66 395.35 474.99 388.3 474.99 389.12' />
      <polygon className='cls-52' points='474.99 389.94 340.66 396.98 340.66 396.16 474.99 389.12 474.99 389.94' />
      <polygon className='cls-50' points='474.99 390.76 340.66 397.8 340.66 396.98 474.99 389.94 474.99 390.76' />
      <polygon className='cls-49' points='474.99 391.58 340.66 398.62 340.66 397.8 474.99 390.76 474.99 391.58' />
      <polygon className='cls-56' points='474.99 392.4 340.66 399.44 340.66 398.62 474.99 391.58 474.99 392.4' />
      <polygon className='cls-55' points='474.99 393.22 340.66 400.26 340.66 399.44 474.99 392.4 474.99 393.22' />
      <polygon className='cls-54' points='474.99 394.04 340.66 401.08 340.66 400.26 474.99 393.22 474.99 394.04' />
      <polygon className='cls-53' points='474.99 394.86 340.66 401.9 340.66 401.08 474.99 394.04 474.99 394.86' />
      <polygon className='cls-85' points='474.99 395.67 340.66 402.71 340.66 401.9 474.99 394.86 474.99 395.67' />
      <polygon className='cls-109' points='474.99 396.49 340.66 403.53 340.66 402.71 474.99 395.67 474.99 396.49' />
      <polygon className='cls-110' points='474.99 397.31 340.66 404.35 340.66 403.53 474.99 396.49 474.99 397.31' />
      <polygon className='cls-84' points='474.99 398.13 340.66 405.17 340.66 404.35 474.99 397.31 474.99 398.13' />
      <polygon className='cls-83' points='474.99 398.95 340.66 405.99 340.66 405.17 474.99 398.13 474.99 398.95' />
      <polygon className='cls-96' points='474.99 399.77 340.66 406.81 340.66 405.99 474.99 398.95 474.99 399.77' />
      <polygon className='cls-97' points='474.99 400.59 340.66 407.63 340.66 406.81 474.99 399.77 474.99 400.59' />
      <polygon className='cls-87' points='474.99 401.41 340.66 408.45 340.66 407.63 474.99 400.59 474.99 401.41' />
      <polygon className='cls-88' points='474.99 402.22 340.66 409.26 340.66 408.45 474.99 401.41 474.99 402.22' />
      <polygon className='cls-86' points='474.99 403.04 340.66 410.08 340.66 409.26 474.99 402.22 474.99 403.04' />
      <polygon className='cls-117' points='474.99 403.86 340.66 410.9 340.66 410.08 474.99 403.04 474.99 403.86' />
      <polygon className='cls-116' points='474.99 404.68 340.66 411.72 340.66 410.9 474.99 403.86 474.99 404.68' />
      <polygon className='cls-112' points='474.99 405.5 340.66 412.54 340.66 411.72 474.99 404.68 474.99 405.5' />
      <polygon className='cls-100' points='474.99 406.32 340.66 413.36 340.66 412.54 474.99 405.5 474.99 406.32' />
      <polygon className='cls-9' points='474.99 407.14 340.66 414.18 340.66 413.36 474.99 406.32 474.99 407.14' />
      <polygon className='cls-6' points='474.99 407.96 340.66 415 340.66 414.18 474.99 407.14 474.99 407.96' />
      <polygon className='cls-8' points='474.99 408.78 340.66 415.82 340.66 415 474.99 407.96 474.99 408.78' />
      <polygon className='cls-7' points='474.99 409.59 340.66 416.63 340.66 415.82 474.99 408.78 474.99 409.59' />
      <polygon className='cls-10' points='474.99 410.41 340.66 417.45 340.66 416.63 474.99 409.59 474.99 410.41' />
      <polygon className='cls-79' points='474.99 411.23 340.66 418.27 340.66 417.45 474.99 410.41 474.99 411.23' />
      <polygon className='cls-80' points='474.99 412.05 340.66 419.09 340.66 418.27 474.99 411.23 474.99 412.05' />
      <polygon className='cls-81' points='474.99 412.87 340.66 419.91 340.66 419.09 474.99 412.05 474.99 412.87' />
      <polygon className='cls-78' points='474.99 413.69 340.66 420.73 340.66 419.91 474.99 412.87 474.99 413.69' />
      <polygon className='cls-113' points='474.99 414.51 340.66 421.55 340.66 420.73 474.99 413.69 474.99 414.51' />
      <polygon className='cls-114' points='474.99 415.33 340.66 422.37 340.66 421.55 474.99 414.51 474.99 415.33' />
      <polygon className='cls-111' points='474.99 416.14 340.66 423.18 340.66 422.37 474.99 415.33 474.99 416.14' />
      <polygon className='cls-115' points='474.99 416.96 340.66 424 340.66 423.18 474.99 416.14 474.99 416.96' />
      <polygon className='cls-90' points='474.99 417.78 340.66 424.82 340.66 424 474.99 416.96 474.99 417.78' />
      <polygon
        className='cls-69'
        points='474.99 418.6 340.69 425.64 340.66 425.16 340.66 424.82 474.99 417.78 474.99 418.6'
      />
      <polygon className='cls-70' points='474.99 419.42 340.73 426.46 340.69 425.64 474.99 418.6 474.99 419.42' />
      <polygon className='cls-68' points='474.99 420.24 340.77 427.27 340.73 426.46 474.99 419.42 474.99 420.24' />
      <polygon className='cls-71' points='474.99 421.06 340.81 428.09 340.77 427.27 474.99 420.24 474.99 421.06' />
      <polygon className='cls-101' points='474.99 421.88 340.86 428.91 340.81 428.09 474.99 421.06 474.99 421.88' />
      <polygon className='cls-103' points='474.99 422.69 340.9 429.72 340.86 428.91 474.99 421.88 474.99 422.69' />
      <polygon className='cls-102' points='474.99 423.51 340.94 430.54 340.9 429.72 474.99 422.69 474.99 423.51' />
      <polygon className='cls-102' points='341.91 448.93 340.94 430.54 474.99 423.51 474.99 448.93 341.91 448.93' />
    </g>
    <g className='cls-136'>
      <polygon className='cls-17' points='531.77 122.82 420.04 103.12 531.77 103.12 531.77 122.82' />
      <polygon className='cls-17' points='531.77 124.01 413.29 103.12 420.04 103.12 531.77 122.82 531.77 124.01' />
      <polygon className='cls-18' points='531.77 125.2 406.55 103.12 413.29 103.12 531.77 124.01 531.77 125.2' />
      <polygon className='cls-11' points='531.77 126.39 399.81 103.12 406.55 103.12 531.77 125.2 531.77 126.39' />
      <polygon className='cls-20' points='531.77 127.58 393.06 103.12 399.81 103.12 531.77 126.39 531.77 127.58' />
      <polygon className='cls-22' points='531.77 128.76 386.32 103.12 393.06 103.12 531.77 127.58 531.77 128.76' />
      <polygon className='cls-23' points='531.77 129.95 379.57 103.12 386.32 103.12 531.77 128.76 531.77 129.95' />
      <polygon className='cls-21' points='531.77 131.14 372.83 103.12 379.57 103.12 531.77 129.95 531.77 131.14' />
      <polygon className='cls-29' points='531.77 132.33 366.09 103.12 372.83 103.12 531.77 131.14 531.77 132.33' />
      <polygon className='cls-28' points='531.77 133.52 359.34 103.12 366.09 103.12 531.77 132.33 531.77 133.52' />
      <polygon className='cls-30' points='531.77 134.71 352.6 103.12 359.34 103.12 531.77 133.52 531.77 134.71' />
      <polygon
        className='cls-32'
        points='531.77 135.9 348.72 103.62 348.81 103.12 352.6 103.12 531.77 134.71 531.77 135.9'
      />
      <polygon className='cls-31' points='531.77 137.09 348.52 104.78 348.72 103.62 531.77 135.9 531.77 137.09' />
      <polygon className='cls-134' points='531.77 138.28 348.31 105.93 348.52 104.78 531.77 137.09 531.77 138.28' />
      <polygon className='cls-133' points='531.77 139.47 348.11 107.08 348.31 105.93 531.77 138.28 531.77 139.47' />
      <polygon className='cls-126' points='531.77 140.66 347.91 108.24 348.11 107.08 531.77 139.47 531.77 140.66' />
      <polygon className='cls-125' points='531.77 141.84 347.7 109.39 347.91 108.24 531.77 140.66 531.77 141.84' />
      <polygon className='cls-41' points='531.77 143.03 347.5 110.54 347.7 109.39 531.77 141.84 531.77 143.03' />
      <polygon className='cls-38' points='531.77 144.22 347.3 111.7 347.5 110.54 531.77 143.03 531.77 144.22' />
      <polygon className='cls-40' points='531.77 145.41 347.09 112.85 347.3 111.7 531.77 144.22 531.77 145.41' />
      <polygon className='cls-37' points='531.77 146.6 346.89 114 347.09 112.85 531.77 145.41 531.77 146.6' />
      <polygon className='cls-39' points='531.77 147.79 346.69 115.15 346.89 114 531.77 146.6 531.77 147.79' />
      <polygon className='cls-122' points='531.77 148.98 346.48 116.31 346.69 115.15 531.77 147.79 531.77 148.98' />
      <polygon className='cls-131' points='531.77 150.17 346.28 117.46 346.48 116.31 531.77 148.98 531.77 150.17' />
      <polygon className='cls-124' points='531.77 151.36 346.08 118.61 346.28 117.46 531.77 150.17 531.77 151.36' />
      <polygon className='cls-123' points='531.77 152.55 345.87 119.77 346.08 118.61 531.77 151.36 531.77 152.55' />
      <polygon className='cls-128' points='531.77 153.74 345.67 120.92 345.87 119.77 531.77 152.55 531.77 153.74' />
      <polygon className='cls-132' points='531.77 154.93 345.47 122.07 345.67 120.92 531.77 153.74 531.77 154.93' />
      <polygon className='cls-129' points='531.77 156.11 345.26 123.23 345.47 122.07 531.77 154.93 531.77 156.11' />
      <polygon className='cls-130' points='531.77 157.3 345.06 124.38 345.26 123.23 531.77 156.11 531.77 157.3' />
      <polygon className='cls-127' points='531.77 158.49 344.86 125.53 345.06 124.38 531.77 157.3 531.77 158.49' />
      <polygon className='cls-15' points='531.77 159.68 344.65 126.69 344.86 125.53 531.77 158.49 531.77 159.68' />
      <polygon className='cls-14' points='531.77 160.87 344.45 127.84 344.65 126.69 531.77 159.68 531.77 160.87' />
      <polygon className='cls-13' points='531.77 162.06 344.25 128.99 344.45 127.84 531.77 160.87 531.77 162.06' />
      <polygon className='cls-12' points='531.77 163.25 344.04 130.15 344.25 128.99 531.77 162.06 531.77 163.25' />
      <polygon className='cls-16' points='531.77 164.44 343.84 131.3 344.04 130.15 531.77 163.25 531.77 164.44' />
      <polygon className='cls-27' points='531.77 165.63 343.64 132.45 343.84 131.3 531.77 164.44 531.77 165.63' />
      <polygon className='cls-25' points='531.77 166.82 343.43 133.61 343.64 132.45 531.77 165.63 531.77 166.82' />
      <polygon className='cls-24' points='531.77 168.01 343.23 134.76 343.43 133.61 531.77 166.82 531.77 168.01' />
      <polygon className='cls-26' points='531.77 169.19 343.03 135.91 343.23 134.76 531.77 168.01 531.77 169.19' />
      <polygon className='cls-43' points='531.77 170.38 342.82 137.07 343.03 135.91 531.77 169.19 531.77 170.38' />
      <polygon className='cls-34' points='531.77 171.57 342.62 138.22 342.82 137.07 531.77 170.38 531.77 171.57' />
      <polygon className='cls-42' points='531.77 172.76 342.42 139.37 342.62 138.22 531.77 171.57 531.77 172.76' />
      <polygon className='cls-36' points='531.77 173.95 342.21 140.53 342.42 139.37 531.77 172.76 531.77 173.95' />
      <polygon
        className='cls-35'
        points='531.77 175.14 342.04 141.69 342.04 141.48 342.21 140.53 531.77 173.95 531.77 175.14'
      />
      <polygon className='cls-45' points='531.77 176.33 342.04 142.88 342.04 141.69 531.77 175.14 531.77 176.33' />
      <polygon className='cls-44' points='531.77 177.52 342.04 144.06 342.04 142.88 531.77 176.33 531.77 177.52' />
      <polygon className='cls-47' points='531.77 178.71 342.04 145.25 342.04 144.06 531.77 177.52 531.77 178.71' />
      <polygon className='cls-46' points='531.77 179.9 342.04 146.44 342.04 145.25 531.77 178.71 531.77 179.9' />
      <polygon className='cls-114' points='531.77 181.09 342.04 147.63 342.04 146.44 531.77 179.9 531.77 181.09' />
      <polygon className='cls-113' points='531.77 182.28 342.04 148.82 342.04 147.63 531.77 181.09 531.77 182.28' />
      <polygon className='cls-118' points='531.77 183.46 342.04 150.01 342.04 148.82 531.77 182.28 531.77 183.46' />
      <polygon className='cls-91' points='531.77 184.65 342.04 151.2 342.04 150.01 531.77 183.46 531.77 184.65' />
      <polygon className='cls-89' points='531.77 185.84 342.04 152.39 342.04 151.2 531.77 184.65 531.77 185.84' />
      <polygon className='cls-106' points='531.77 187.03 342.04 153.58 342.04 152.39 531.77 185.84 531.77 187.03' />
      <polygon className='cls-107' points='531.77 188.22 342.04 154.77 342.04 153.58 531.77 187.03 531.77 188.22' />
      <polygon className='cls-108' points='531.77 189.41 342.04 155.96 342.04 154.77 531.77 188.22 531.77 189.41' />
      <polygon className='cls-105' points='531.77 190.6 342.04 157.15 342.04 155.96 531.77 189.41 531.77 190.6' />
      <polygon className='cls-74' points='531.77 191.79 342.04 158.33 342.04 157.15 531.77 190.6 531.77 191.79' />
      <polygon className='cls-75' points='531.77 192.98 342.04 159.52 342.04 158.33 531.77 191.79 531.77 192.98' />
      <polygon className='cls-77' points='531.77 194.17 342.04 160.71 342.04 159.52 531.77 192.98 531.77 194.17' />
      <polygon className='cls-82' points='531.77 195.36 342.04 161.9 342.04 160.71 531.77 194.17 531.77 195.36' />
      <polygon className='cls-76' points='531.77 196.55 342.04 163.09 342.04 161.9 531.77 195.36 531.77 196.55' />
      <polygon className='cls-99' points='531.77 197.73 342.04 164.28 342.04 163.09 531.77 196.55 531.77 197.73' />
      <polygon className='cls-98' points='531.77 198.92 342.04 165.47 342.04 164.28 531.77 197.73 531.77 198.92' />
      <polygon className='cls-92' points='531.77 200.11 342.04 166.66 342.04 165.47 531.77 198.92 531.77 200.11' />
      <polygon className='cls-93' points='531.77 201.3 342.04 167.85 342.04 166.66 531.77 200.11 531.77 201.3' />
      <polygon className='cls-94' points='531.77 202.49 342.04 169.04 342.04 167.85 531.77 201.3 531.77 202.49' />
      <polygon className='cls-104' points='531.77 203.68 342.04 170.23 342.04 169.04 531.77 202.49 531.77 203.68' />
      <polygon className='cls-95' points='531.77 204.87 342.04 171.42 342.04 170.23 531.77 203.68 531.77 204.87' />
      <polygon className='cls-119' points='531.77 206.06 342.04 172.6 342.04 171.42 531.77 204.87 531.77 206.06' />
      <polygon
        className='cls-120'
        points='531.77 206.65 531.67 207.23 342.04 173.79 342.04 172.6 531.77 206.06 531.77 206.65'
      />
      <polygon className='cls-62' points='531.67 207.23 531.46 208.38 342.04 174.98 342.04 173.79 531.67 207.23' />
      <polygon className='cls-61' points='531.46 208.38 531.26 209.54 342.04 176.17 342.04 174.98 531.46 208.38' />
      <polygon className='cls-63' points='531.26 209.54 531.06 210.69 342.04 177.36 342.04 176.17 531.26 209.54' />
      <polygon className='cls-60' points='531.06 210.69 530.85 211.84 342.04 178.55 342.04 177.36 531.06 210.69' />
      <polygon className='cls-72' points='530.85 211.84 530.65 213 342.04 179.74 342.04 178.55 530.85 211.84' />
      <polygon className='cls-73' points='530.65 213 530.45 214.15 342.04 180.93 342.04 179.74 530.65 213' />
      <polygon className='cls-59' points='530.45 214.15 530.24 215.3 342.04 182.12 342.04 180.93 530.45 214.15' />
      <polygon className='cls-58' points='530.24 215.3 530.04 216.46 342.04 183.31 342.04 182.12 530.24 215.3' />
      <polygon className='cls-57' points='530.04 216.46 529.84 217.61 342.04 184.5 342.04 183.31 530.04 216.46' />
      <polygon className='cls-64' points='529.84 217.61 529.63 218.76 342.04 185.68 342.04 184.5 529.84 217.61' />
      <polygon className='cls-65' points='529.63 218.76 529.43 219.92 342.04 186.87 342.04 185.68 529.63 218.76' />
      <polygon className='cls-66' points='529.43 219.92 529.23 221.07 342.04 188.06 342.04 186.87 529.43 219.92' />
      <polygon className='cls-67' points='529.23 221.07 529.02 222.22 342.04 189.25 342.04 188.06 529.23 221.07' />
      <polygon className='cls-48' points='529.02 222.22 528.82 223.38 342.04 190.44 342.04 189.25 529.02 222.22' />
      <polygon className='cls-51' points='528.82 223.38 528.62 224.53 342.04 191.63 342.04 190.44 528.82 223.38' />
      <polygon className='cls-52' points='528.62 224.53 528.41 225.68 342.04 192.82 342.04 191.63 528.62 224.53' />
      <polygon className='cls-50' points='528.41 225.68 528.21 226.84 342.04 194.01 342.04 192.82 528.41 225.68' />
      <polygon className='cls-49' points='528.21 226.84 528.01 227.99 342.04 195.2 342.04 194.01 528.21 226.84' />
      <polygon className='cls-56' points='528.01 227.99 527.8 229.14 342.04 196.39 342.04 195.2 528.01 227.99' />
      <polygon className='cls-55' points='527.8 229.14 527.6 230.29 342.04 197.58 342.04 196.39 527.8 229.14' />
      <polygon className='cls-54' points='527.6 230.29 527.4 231.45 342.04 198.77 342.04 197.58 527.6 230.29' />
      <polygon className='cls-53' points='527.4 231.45 527.19 232.6 342.04 199.95 342.04 198.77 527.4 231.45' />
      <polygon className='cls-85' points='527.19 232.6 526.99 233.75 342.04 201.14 342.04 199.95 527.19 232.6' />
      <polygon className='cls-109' points='526.99 233.75 526.79 234.91 342.04 202.33 342.04 201.14 526.99 233.75' />
      <polygon className='cls-110' points='526.79 234.91 526.58 236.06 342.04 203.52 342.04 202.33 526.79 234.91' />
      <polygon className='cls-84' points='526.58 236.06 526.38 237.21 342.04 204.71 342.04 203.52 526.58 236.06' />
      <polygon className='cls-83' points='526.38 237.21 526.18 238.37 342.04 205.9 342.04 204.71 526.38 237.21' />
      <polygon className='cls-96' points='526.18 238.37 525.97 239.52 342.04 207.09 342.04 205.9 526.18 238.37' />
      <polygon className='cls-97' points='525.97 239.52 525.77 240.67 342.04 208.28 342.04 207.09 525.97 239.52' />
      <polygon className='cls-87' points='525.77 240.67 525.57 241.83 342.04 209.47 342.04 208.28 525.77 240.67' />
      <polygon className='cls-88' points='525.57 241.83 525.36 242.98 342.04 210.66 342.04 209.47 525.57 241.83' />
      <polygon className='cls-86' points='525.36 242.98 525.16 244.13 342.04 211.85 342.04 210.66 525.36 242.98' />
      <polygon className='cls-117' points='525.16 244.13 524.96 245.29 342.04 213.04 342.04 211.85 525.16 244.13' />
      <polygon className='cls-116' points='524.96 245.29 524.75 246.44 342.04 214.22 342.04 213.04 524.96 245.29' />
      <polygon className='cls-112' points='524.75 246.44 524.55 247.59 342.04 215.41 342.04 214.22 524.75 246.44' />
      <polygon className='cls-100' points='524.55 247.59 524.35 248.75 342.04 216.6 342.04 215.41 524.55 247.59' />
      <polygon className='cls-9' points='524.35 248.75 524.14 249.9 342.04 217.79 342.04 216.6 524.35 248.75' />
      <polygon className='cls-6' points='524.14 249.9 523.94 251.05 342.04 218.98 342.04 217.79 524.14 249.9' />
      <polygon className='cls-8' points='523.94 251.05 523.74 252.21 342.04 220.17 342.04 218.98 523.94 251.05' />
      <polygon className='cls-7' points='523.74 252.21 523.53 253.36 342.04 221.36 342.04 220.17 523.74 252.21' />
      <polygon className='cls-10' points='523.53 253.36 523.33 254.51 342.04 222.55 342.04 221.36 523.53 253.36' />
      <polygon className='cls-79' points='523.33 254.51 523.13 255.67 342.04 223.74 342.04 222.55 523.33 254.51' />
      <polygon className='cls-80' points='523.13 255.67 522.92 256.82 342.04 224.93 342.04 223.74 523.13 255.67' />
      <polygon className='cls-81' points='522.92 256.82 522.72 257.97 342.04 226.12 342.04 224.93 522.92 256.82' />
      <polygon className='cls-78' points='522.72 257.97 522.52 259.13 342.04 227.3 342.04 226.12 522.72 257.97' />
      <polygon className='cls-113' points='522.52 259.13 522.31 260.28 342.04 228.49 342.04 227.3 522.52 259.13' />
      <polygon className='cls-114' points='522.31 260.28 522.11 261.43 342.04 229.68 342.04 228.49 522.31 260.28' />
      <polygon className='cls-111' points='522.11 261.43 521.91 262.59 342.04 230.87 342.04 229.68 522.11 261.43' />
      <polygon className='cls-115' points='521.91 262.59 521.7 263.74 342.04 232.06 342.04 230.87 521.91 262.59' />
      <polygon className='cls-90' points='521.7 263.74 521.5 264.89 342.04 233.25 342.04 232.06 521.7 263.74' />
      <polygon className='cls-69' points='521.5 264.89 521.3 266.05 342.04 234.44 342.04 233.25 521.5 264.89' />
      <polygon className='cls-70' points='521.3 266.05 521.09 267.2 342.04 235.63 342.04 234.44 521.3 266.05' />
      <polygon className='cls-68' points='521.09 267.2 520.89 268.35 342.04 236.82 342.04 235.63 521.09 267.2' />
      <polygon className='cls-71' points='520.89 268.35 520.69 269.51 342.04 238.01 342.04 236.82 520.89 268.35' />
      <polygon className='cls-101' points='520.69 269.51 520.48 270.66 342.04 239.2 342.04 238.01 520.69 269.51' />
      <polygon className='cls-103' points='520.48 270.66 520.28 271.81 342.04 240.39 342.04 239.2 520.48 270.66' />
      <polygon className='cls-102' points='520.28 271.81 520.08 272.97 342.04 241.57 342.04 240.39 520.28 271.81' />
      <polygon className='cls-102' points='520.08 272.97 516.39 293.9 342.04 293.9 342.04 241.57 520.08 272.97' />
    </g>
    <g>
      <path
        className='cls-5'
        d='M154.79,458.78h88.7c1.14,0,2.07-.92,2.07-2.07s-.92-2.07-2.07-2.07h-88.7c-1.14,0-2.07.92-2.07,2.07s.92,2.07,2.07,2.07Z'
      />
      <path
        className='cls-5'
        d='M106.3,458.78h35.47c1.14,0,2.07-.92,2.07-2.07s-.92-2.07-2.07-2.07h-35.47c-1.14,0-2.07.92-2.07,2.07s.92,2.07,2.07,2.07Z'
      />
      <path
        className='cls-5'
        d='M254.54,458.78h238.48c1.14,0,2.07-.92,2.07-2.07s-.92-2.07-2.07-2.07h-238.48c-1.14,0-2.07.92-2.07,2.07s.92,2.07,2.07,2.07Z'
      />
    </g>
    <path className='cls-19' d='M267.92,207.04l-9.29,10.1c-2.14,2.32-5.99.45-5.49-2.66l2.19-13.66,12.59,6.23Z' />
    <g>
      <g className='cls-137'>
        <polygon className='cls-17' points='227.44 163.82 64.46 192.56 64.46 163.82 227.44 163.82' />
        <polygon className='cls-17' points='237.27 163.82 64.46 194.29 64.46 192.56 227.44 163.82 237.27 163.82' />
        <polygon className='cls-18' points='247.11 163.82 64.46 196.02 64.46 194.29 237.27 163.82 247.11 163.82' />
        <polygon className='cls-11' points='256.95 163.82 64.46 197.76 64.46 196.02 247.11 163.82 256.95 163.82' />
        <polygon className='cls-20' points='266.78 163.82 64.46 199.49 64.46 197.76 256.95 163.82 266.78 163.82' />
        <polygon className='cls-22' points='276.62 163.82 64.46 201.23 64.46 199.49 266.78 163.82 276.62 163.82' />
        <polygon className='cls-23' points='286.46 163.82 64.46 202.96 64.46 201.23 276.62 163.82 286.46 163.82' />
        <polygon className='cls-21' points='296.3 163.82 64.46 204.7 64.46 202.96 286.46 163.82 296.3 163.82' />
        <polygon className='cls-29' points='306.13 163.82 64.46 206.43 64.46 204.7 296.3 163.82 306.13 163.82' />
        <polygon className='cls-28' points='315.97 163.82 64.46 208.17 64.46 206.43 306.13 163.82 315.97 163.82' />
        <polygon className='cls-30' points='325.81 163.82 64.46 209.9 64.46 208.17 315.97 163.82 325.81 163.82' />
        <polygon
          className='cls-32'
          points='330.05 163.82 330.22 164.77 64.46 211.63 64.46 209.9 325.81 163.82 330.05 163.82'
        />
        <polygon className='cls-31' points='330.22 164.77 330.52 166.46 64.46 213.37 64.46 211.63 330.22 164.77' />
        <polygon className='cls-134' points='330.52 166.46 330.81 168.14 64.46 215.1 64.46 213.37 330.52 166.46' />
        <polygon className='cls-133' points='330.81 168.14 331.11 169.82 64.46 216.84 64.46 215.1 330.81 168.14' />
        <polygon className='cls-126' points='331.11 169.82 331.41 171.5 64.46 218.57 64.46 216.84 331.11 169.82' />
        <polygon className='cls-125' points='331.41 171.5 331.7 173.18 64.46 220.31 64.46 218.57 331.41 171.5' />
        <polygon className='cls-41' points='331.7 173.18 332 174.87 64.46 222.04 64.46 220.31 331.7 173.18' />
        <polygon className='cls-38' points='332 174.87 332.3 176.55 64.46 223.78 64.46 222.04 332 174.87' />
        <polygon className='cls-40' points='332.3 176.55 332.59 178.23 64.46 225.51 64.46 223.78 332.3 176.55' />
        <polygon className='cls-37' points='332.59 178.23 332.89 179.91 64.46 227.25 64.46 225.51 332.59 178.23' />
        <polygon className='cls-39' points='332.89 179.91 333.19 181.6 64.46 228.98 64.46 227.25 332.89 179.91' />
        <polygon className='cls-122' points='333.19 181.6 333.48 183.28 64.46 230.71 64.46 228.98 333.19 181.6' />
        <polygon className='cls-131' points='333.48 183.28 333.78 184.96 64.46 232.45 64.46 230.71 333.48 183.28' />
        <polygon className='cls-124' points='333.78 184.96 334.08 186.64 64.46 234.18 64.46 232.45 333.78 184.96' />
        <polygon className='cls-123' points='334.08 186.64 334.37 188.32 64.46 235.92 64.46 234.18 334.08 186.64' />
        <polygon className='cls-128' points='334.37 188.32 334.67 190.01 64.46 237.65 64.46 235.92 334.37 188.32' />
        <polygon className='cls-132' points='334.67 190.01 334.96 191.69 64.46 239.39 64.46 237.65 334.67 190.01' />
        <polygon className='cls-129' points='334.96 191.69 335.26 193.37 64.46 241.12 64.46 239.39 334.96 191.69' />
        <polygon className='cls-130' points='335.26 193.37 335.56 195.05 64.46 242.86 64.46 241.12 335.26 193.37' />
        <polygon className='cls-127' points='335.56 195.05 335.85 196.74 64.46 244.59 64.46 242.86 335.56 195.05' />
        <polygon className='cls-15' points='335.85 196.74 336.15 198.42 64.46 246.33 64.46 244.59 335.85 196.74' />
        <polygon className='cls-14' points='336.15 198.42 336.45 200.1 64.46 248.06 64.46 246.33 336.15 198.42' />
        <polygon className='cls-13' points='336.45 200.1 336.74 201.78 64.46 249.79 64.46 248.06 336.45 200.1' />
        <polygon className='cls-12' points='336.74 201.78 337.04 203.46 64.46 251.53 64.46 249.79 336.74 201.78' />
        <polygon className='cls-16' points='337.04 203.46 337.34 205.15 64.46 253.26 64.46 251.53 337.04 203.46' />
        <polygon className='cls-27' points='337.34 205.15 337.63 206.83 64.46 255 64.46 253.26 337.34 205.15' />
        <polygon className='cls-25' points='337.63 206.83 337.93 208.51 64.46 256.73 64.46 255 337.63 206.83' />
        <polygon className='cls-24' points='337.93 208.51 338.23 210.19 64.46 258.47 64.46 256.73 337.93 208.51' />
        <polygon className='cls-26' points='338.23 210.19 338.52 211.88 64.46 260.2 64.46 258.47 338.23 210.19' />
        <polygon className='cls-43' points='338.52 211.88 338.82 213.56 64.46 261.94 64.46 260.2 338.52 211.88' />
        <polygon className='cls-34' points='338.82 213.56 339.12 215.24 64.46 263.67 64.46 261.94 338.82 213.56' />
        <polygon className='cls-42' points='339.12 215.24 339.41 216.92 64.46 265.41 64.46 263.67 339.12 215.24' />
        <polygon className='cls-36' points='339.41 216.92 339.71 218.61 64.46 267.14 64.46 265.41 339.41 216.92' />
        <polygon className='cls-35' points='339.71 218.61 340.01 220.29 64.46 268.87 64.46 267.14 339.71 218.61' />
        <polygon className='cls-45' points='340.01 220.29 340.3 221.97 64.46 270.61 64.46 268.87 340.01 220.29' />
        <polygon className='cls-44' points='340.3 221.97 340.6 223.65 64.46 272.34 64.46 270.61 340.3 221.97' />
        <polygon className='cls-47' points='340.6 223.65 340.9 225.33 64.46 274.08 64.46 272.34 340.6 223.65' />
        <polygon className='cls-46' points='340.9 225.33 341.19 227.02 64.46 275.81 64.46 274.08 340.9 225.33' />
        <polygon
          className='cls-114'
          points='341.19 227.02 341.2 227.05 341.2 228.75 64.46 277.55 64.46 275.81 341.19 227.02'
        />
        <polygon className='cls-113' points='341.2 230.48 64.46 279.28 64.46 277.55 341.2 228.75 341.2 230.48' />
        <polygon className='cls-118' points='341.2 232.22 64.46 281.02 64.46 279.28 341.2 230.48 341.2 232.22' />
        <polygon className='cls-91' points='341.2 233.95 64.46 282.75 64.46 281.02 341.2 232.22 341.2 233.95' />
        <polygon className='cls-89' points='341.2 235.69 64.46 284.49 64.46 282.75 341.2 233.95 341.2 235.69' />
        <polygon className='cls-106' points='341.2 237.42 64.46 286.22 64.46 284.49 341.2 235.69 341.2 237.42' />
        <polygon className='cls-107' points='341.2 239.16 64.46 287.95 64.46 286.22 341.2 237.42 341.2 239.16' />
        <polygon className='cls-108' points='341.2 240.89 64.46 289.69 64.46 287.95 341.2 239.16 341.2 240.89' />
        <polygon className='cls-105' points='341.2 242.63 64.46 291.42 64.46 289.69 341.2 240.89 341.2 242.63' />
        <polygon className='cls-74' points='341.2 244.36 64.46 293.16 64.46 291.42 341.2 242.63 341.2 244.36' />
        <polygon className='cls-75' points='341.2 246.09 64.46 294.89 64.46 293.16 341.2 244.36 341.2 246.09' />
        <polygon className='cls-77' points='341.2 247.83 64.46 296.63 64.46 294.89 341.2 246.09 341.2 247.83' />
        <polygon className='cls-82' points='341.2 249.56 64.46 298.36 64.46 296.63 341.2 247.83 341.2 249.56' />
        <polygon className='cls-76' points='341.2 251.3 64.46 300.1 64.46 298.36 341.2 249.56 341.2 251.3' />
        <polygon className='cls-99' points='341.2 253.03 64.46 301.83 64.46 300.1 341.2 251.3 341.2 253.03' />
        <polygon className='cls-98' points='341.2 254.77 64.46 303.56 64.46 301.83 341.2 253.03 341.2 254.77' />
        <polygon className='cls-92' points='341.2 256.5 64.46 305.3 64.46 303.56 341.2 254.77 341.2 256.5' />
        <polygon className='cls-93' points='341.2 258.24 64.46 307.03 64.46 305.3 341.2 256.5 341.2 258.24' />
        <polygon
          className='cls-94'
          points='341.2 259.97 64.66 308.73 64.46 307.56 64.46 307.03 341.2 258.24 341.2 259.97'
        />
        <polygon className='cls-104' points='341.2 261.71 64.96 310.41 64.66 308.73 341.2 259.97 341.2 261.71' />
        <polygon className='cls-95' points='341.2 263.44 65.26 312.1 64.96 310.41 341.2 261.71 341.2 263.44' />
        <polygon className='cls-119' points='341.2 265.17 65.55 313.78 65.26 312.1 341.2 263.44 341.2 265.17' />
        <polygon className='cls-120' points='341.2 266.91 65.85 315.46 65.55 313.78 341.2 265.17 341.2 266.91' />
        <polygon className='cls-62' points='341.2 268.64 66.15 317.14 65.85 315.46 341.2 266.91 341.2 268.64' />
        <polygon className='cls-61' points='341.2 270.38 66.44 318.83 66.15 317.14 341.2 268.64 341.2 270.38' />
        <polygon className='cls-63' points='341.2 272.11 66.74 320.51 66.44 318.83 341.2 270.38 341.2 272.11' />
        <polygon className='cls-60' points='341.2 273.85 67.04 322.19 66.74 320.51 341.2 272.11 341.2 273.85' />
        <polygon className='cls-72' points='341.2 275.58 67.33 323.87 67.04 322.19 341.2 273.85 341.2 275.58' />
        <polygon className='cls-73' points='341.2 277.32 67.63 325.55 67.33 323.87 341.2 275.58 341.2 277.32' />
        <polygon className='cls-59' points='341.2 279.05 67.93 327.24 67.63 325.55 341.2 277.32 341.2 279.05' />
        <polygon className='cls-58' points='341.2 280.79 68.22 328.92 67.93 327.24 341.2 279.05 341.2 280.79' />
        <polygon className='cls-57' points='341.2 282.52 68.52 330.6 68.22 328.92 341.2 280.79 341.2 282.52' />
        <polygon className='cls-64' points='341.2 284.25 68.82 332.28 68.52 330.6 341.2 282.52 341.2 284.25' />
        <polygon className='cls-65' points='341.2 285.99 69.11 333.97 68.82 332.28 341.2 284.25 341.2 285.99' />
        <polygon className='cls-66' points='341.2 287.72 69.41 335.65 69.11 333.97 341.2 285.99 341.2 287.72' />
        <polygon className='cls-67' points='341.2 289.46 69.71 337.33 69.41 335.65 341.2 287.72 341.2 289.46' />
        <polygon className='cls-48' points='341.2 291.19 70 339.01 69.71 337.33 341.2 289.46 341.2 291.19' />
        <polygon className='cls-51' points='341.2 292.93 70.3 340.69 70 339.01 341.2 291.19 341.2 292.93' />
        <polygon className='cls-52' points='341.2 294.66 70.6 342.38 70.3 340.69 341.2 292.93 341.2 294.66' />
        <polygon className='cls-50' points='341.2 296.4 70.89 344.06 70.6 342.38 341.2 294.66 341.2 296.4' />
        <polygon className='cls-49' points='341.2 298.13 71.19 345.74 70.89 344.06 341.2 296.4 341.2 298.13' />
        <polygon className='cls-56' points='341.2 299.87 71.49 347.42 71.19 345.74 341.2 298.13 341.2 299.87' />
        <polygon className='cls-55' points='341.2 301.6 71.78 349.11 71.49 347.42 341.2 299.87 341.2 301.6' />
        <polygon className='cls-54' points='341.2 303.33 72.08 350.79 71.78 349.11 341.2 301.6 341.2 303.33' />
        <polygon className='cls-53' points='341.2 305.07 72.38 352.47 72.08 350.79 341.2 303.33 341.2 305.07' />
        <polygon className='cls-85' points='341.2 306.8 72.67 354.15 72.38 352.47 341.2 305.07 341.2 306.8' />
        <polygon className='cls-109' points='341.2 308.54 72.97 355.83 72.67 354.15 341.2 306.8 341.2 308.54' />
        <polygon className='cls-110' points='341.2 310.27 73.27 357.52 72.97 355.83 341.2 308.54 341.2 310.27' />
        <polygon className='cls-84' points='341.2 312.01 73.56 359.2 73.27 357.52 341.2 310.27 341.2 312.01' />
        <polygon className='cls-83' points='341.2 313.74 73.86 360.88 73.56 359.2 341.2 312.01 341.2 313.74' />
        <polygon className='cls-96' points='341.2 315.48 74.16 362.56 73.86 360.88 341.2 313.74 341.2 315.48' />
        <polygon className='cls-97' points='341.2 317.21 74.45 364.25 74.16 362.56 341.2 315.48 341.2 317.21' />
        <polygon className='cls-87' points='341.2 318.95 74.75 365.93 74.45 364.25 341.2 317.21 341.2 318.95' />
        <polygon className='cls-88' points='341.2 320.68 75.05 367.61 74.75 365.93 341.2 318.95 341.2 320.68' />
        <polygon className='cls-86' points='341.2 322.41 75.34 369.29 75.05 367.61 341.2 320.68 341.2 322.41' />
        <polygon className='cls-117' points='341.2 324.15 75.64 370.97 75.34 369.29 341.2 322.41 341.2 324.15' />
        <polygon className='cls-116' points='341.2 325.88 75.94 372.66 75.64 370.97 341.2 324.15 341.2 325.88' />
        <polygon className='cls-112' points='341.2 327.62 76.23 374.34 75.94 372.66 341.2 325.88 341.2 327.62' />
        <polygon className='cls-100' points='341.2 329.35 76.53 376.02 76.23 374.34 341.2 327.62 341.2 329.35' />
        <polygon className='cls-9' points='341.2 331.09 76.83 377.7 76.53 376.02 341.2 329.35 341.2 331.09' />
        <polygon className='cls-6' points='341.2 332.82 77.12 379.39 76.83 377.7 341.2 331.09 341.2 332.82' />
        <polygon className='cls-8' points='341.2 334.56 77.42 381.07 77.12 379.39 341.2 332.82 341.2 334.56' />
        <polygon className='cls-7' points='341.2 336.29 77.71 382.75 77.42 381.07 341.2 334.56 341.2 336.29' />
        <polygon className='cls-10' points='341.2 338.03 78.01 384.43 77.71 382.75 341.2 336.29 341.2 338.03' />
        <polygon className='cls-79' points='341.2 339.76 78.31 386.11 78.01 384.43 341.2 338.03 341.2 339.76' />
        <polygon className='cls-80' points='341.2 341.49 78.6 387.8 78.31 386.11 341.2 339.76 341.2 341.49' />
        <polygon className='cls-81' points='341.2 343.23 78.9 389.48 78.6 387.8 341.2 341.49 341.2 343.23' />
        <polygon className='cls-78' points='341.2 344.96 79.2 391.16 78.9 389.48 341.2 343.23 341.2 344.96' />
        <polygon className='cls-113' points='341.2 346.7 79.49 392.84 79.2 391.16 341.2 344.96 341.2 346.7' />
        <polygon className='cls-114' points='341.2 348.43 79.79 394.53 79.49 392.84 341.2 346.7 341.2 348.43' />
        <polygon className='cls-111' points='341.2 350.17 80.09 396.21 79.79 394.53 341.2 348.43 341.2 350.17' />
        <polygon className='cls-115' points='341.2 351.9 80.38 397.89 80.09 396.21 341.2 350.17 341.2 351.9' />
        <polygon className='cls-90' points='341.2 353.64 80.68 399.57 80.38 397.89 341.2 351.9 341.2 353.64' />
        <polygon className='cls-69' points='341.2 355.37 80.98 401.25 80.68 399.57 341.2 353.64 341.2 355.37' />
        <polygon className='cls-70' points='341.2 357.1 81.27 402.94 80.98 401.25 341.2 355.37 341.2 357.1' />
        <polygon className='cls-68' points='341.2 358.84 81.57 404.62 81.27 402.94 341.2 357.1 341.2 358.84' />
        <polygon className='cls-71' points='341.2 360.57 81.87 406.3 81.57 404.62 341.2 358.84 341.2 360.57' />
        <polygon className='cls-101' points='341.2 362.31 82.16 407.98 81.87 406.3 341.2 360.57 341.2 362.31' />
        <polygon className='cls-103' points='341.2 364.04 82.46 409.67 82.16 407.98 341.2 362.31 341.2 364.04' />
        <polygon className='cls-102' points='341.2 365.78 82.76 411.35 82.46 409.67 341.2 364.04 341.2 365.78' />
        <polygon className='cls-102' points='88.18 442.1 82.76 411.35 341.2 365.78 341.2 442.1 88.18 442.1' />
      </g>
      <g>
        <path
          className='cls-135'
          d='M185.53,313.3c-1.31.23-2.15,1.54-1.81,2.82,3.66,13.55,17.12,22.3,31.21,19.82,14.09-2.48,23.75-15.31,22.55-29.3-.11-1.32-1.35-2.27-2.66-2.04l-49.29,8.69Z'
        />
        <path
          className='cls-33'
          d='M232.44,324.9c-5.71-3.91-12.88-5.68-20.23-4.38-7.35,1.3-13.48,5.42-17.51,11.04,5.71,3.91,12.88,5.68,20.23,4.38,7.35-1.3,13.48-5.42,17.51-11.04Z'
        />
        <path
          className='cls-135'
          d='M183.57,282.09c-.75-4.26-4.81-7.1-9.07-6.35-4.26.75-7.1,4.81-6.35,9.07.75,4.26,4.81,7.1,9.07,6.35,4.26-.75,7.1-4.81,6.35-9.07Z'
        />
        <path
          className='cls-135'
          d='M241.36,271.65c-.75-4.26-4.81-7.1-9.07-6.35-4.26.75-7.1,4.81-6.35,9.07.75,4.26,4.81,7.1,9.07,6.35,4.26-.75,7.1-4.81,6.35-9.07Z'
        />
      </g>
    </g>
    <circle className='cls-19' cx='277.86' cy='170.69' r='39.31' />
    <path
      className='cls-3'
      d='M285.14,156.91c-2.9,0-5.54,1.45-7.28,3.94-1.74-2.52-4.34-3.94-7.28-3.94-5.39,0-9.3,4.12-9.3,9.79,0,2.7,1.07,5.24,2.99,7.13l13.03,13.11c.14.14.33.22.53.22h0c.2,0,.39-.08.53-.22l13.09-13.11c1.93-1.9,3-4.43,3-7.14,0-5.67-3.91-9.79-9.3-9.79Z'
    />
    <circle className='cls-19' cx='337.54' cy='298.45' r='4.77' />
    <circle className='cls-4' cx='552.51' cy='318.94' r='10.34' />
    <circle className='cls-19' cx='262.31' cy='421.77' r='8.66' />
    <circle className='cls-4' cx='80.69' cy='201.13' r='8.66' />
    <g>
      <path
        className='cls-135'
        d='M423.18,177.68c.52-2.65-1.21-5.22-3.87-5.74-2.65-.52-5.22,1.21-5.74,3.87s1.21,5.22,3.87,5.74c2.65.52,5.22-1.21,5.74-3.87Z'
      />
      <path
        className='cls-135'
        d='M459.22,184.55c.52-2.65-1.21-5.22-3.87-5.74-2.65-.52-5.22,1.21-5.74,3.87-.52,2.65,1.21,5.22,3.87,5.74,2.65.52,5.22-1.21,5.74-3.87Z'
      />
      <path
        className='cls-135'
        d='M459.57,198.74c-.24.63-.54,1.24-.85,1.85-.65,1.32-1.42,2.59-2.32,3.79-.24.33-.47.66-.73.96-4.8,5.96-11.98,9.67-19.57,10.07-.4.02-.81.05-1.23.04-1.52,0-3.02-.1-4.44-.35-.27-.03-.53-.08-.8-.13-12.52-2.38-21.71-13.35-21.87-26.08-.02-1.35,1.07-2.46,2.41-2.48,1.37-.01,2.46,1.07,2.48,2.41.11,9.33,6.18,17.51,14.8,20.47,1,.39,2.04.66,3.1.86,1.39.27,2.79.38,4.31.4,6.91-.05,13.48-3.43,17.61-9.07,1.05-1.44,1.91-2.97,2.57-4.59.23-.55.63-.97,1.13-1.25.61-.31,1.36-.36,2.06-.08,1.25.51,1.85,1.92,1.34,3.17Z'
      />
    </g>
    <path
      className='cls-135'
      d='M395.04,377.24c-1.13.04-2.02,1.06-1.83,2.18,1.34,7.87,8.35,13.72,16.54,13.4,8.19-.32,14.72-6.69,15.45-14.64.1-1.13-.86-2.08-1.99-2.03l-28.17,1.1Z'
    />
    <path
      className='cls-33'
      d='M420.85,387.78c-3.02-2.73-7.07-4.34-11.46-4.17-4.39.17-8.3,2.09-11.1,5.05,3.02,2.73,7.06,4.34,11.46,4.17s8.3-2.09,11.1-5.05Z'
    />
    <path
      className='cls-135'
      d='M402.89,373.37h0c-.61.02-1.13-.45-1.16-1.07-.02-.61-.54-1.09-1.16-1.07h0c-.61.03-1.09.54-1.06,1.16.02.61-.45,1.13-1.06,1.16h0c-.61.02-1.13-.45-1.16-1.07-.07-1.84,1.36-3.39,3.19-3.47h.01c.89-.04,1.74.28,2.4.89.65.61,1.03,1.43,1.07,2.32.02.61-.45,1.13-1.06,1.16Z'
    />
    <path
      className='cls-135'
      d='M419.58,372.65h0c-.61.02-1.13-.45-1.16-1.07-.02-.61-.54-1.09-1.16-1.07h0c-.61.03-1.09.54-1.06,1.16.02.61-.45,1.13-1.06,1.16h0c-.61.02-1.13-.45-1.16-1.07-.07-1.84,1.36-3.39,3.19-3.47h.01c.89-.04,1.74.28,2.4.88.65.61,1.03,1.43,1.07,2.32.02.61-.45,1.13-1.06,1.16Z'
    />
  </svg>
);
